import { type FC } from 'react';
import { Link, type TestProps } from '@direct-frontend/components';
import { MERCHANTS_SHOP_NAME_HELP_URL } from '#shared/lib/const';
import { InfoBlock } from '#shared/ui/InfoBlock';

export const CompanyNameModerationBanner: FC<TestProps> = ({
    'data-testid': dataTestId = 'CompanyNameModerationBanner',
}) => (
    <InfoBlock type="icon" color="error" data-testid={dataTestId}>
        Название магазина или бренда не прошло проверку. Укажите другое название.{' '}
        <Link href={MERCHANTS_SHOP_NAME_HELP_URL} target="_blank" rel="noreferrer">
            Подробнее о проверке
        </Link>
    </InfoBlock>
);
